var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewspaper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 16,
    width: 18,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M.2 2.5A2.2 2.2 0 0 1 2.4.3h8.8a2.2 2.2 0 0 1 2.2 2.2v11a2.2 2.2 0 0 0 2.2 2.2H2.4a2.2 2.2 0 0 1-2.2-2.2zm3.3 1.1h6.6V8H3.5zm6.6 6.6H3.5v2.2h6.6z",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 4.7h1.1a2.2 2.2 0 0 1 2.2 2.2v6.05a1.65 1.65 0 1 1-3.3 0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewspaper);
export default __webpack_public_path__ + "static/media/newspaper.e91aafe6985a7a5c9649ed1e7d3617c8.svg";
export { ForwardRef as ReactComponent };